<template>
	<div>
		<div class="inlin colwhite titleIcon title">
			<i class="iconfont iconvisImageCenter tableIcon"></i>
			<span class="fz14">影像中心排名</span>
			<span class="sort-icon" @click="dataSort">
				<svg-icon class="fz18 marr4" :icon-class="sortRule === 0 ? 'icon_sort_desc' : 'icon_sort_asce'"></svg-icon>
			</span>
		</div>
		<div class="legend-list">
			<div 
				class="legend-item"
				v-for="(item, index) in legend" 
				:key="index" 
				@click="switchLegend(item)"
			>
				<div class="square" :style="selectLegend === item.field ? {background: item.color} : {}"></div>
				<div class="label" :style="selectLegend === item.field ? {color: '#ffffff'} : {}">{{ item.label }}</div>
			</div>
		</div>
		<div class="supervisorRank disflex" ref="breadcrumb">
			<div v-if="doctorsHospital.length > 0" ref="container">
				<div class="echarts"><div id="container"></div></div>
			</div>
			<div v-else class="echartsNull">
				<div><svg-icon class="fz18 marr4" icon-class="icon-default-Nodata"></svg-icon></div>
				<div class="text">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { mapState, mapActions, mapMutations} from 'vuex'
import echarts from 'echarts';
import lodash from 'lodash';
export default {
	data() {
		return {
			myChart: null,
			height: 25,
			barMaxWidth: 7,
			legend: [
				{ label: '影像', field: 'ImageAvgScore', color: '#36DDA5' },
				{ label: '报告', field: 'ReportAvgScore', color: '#248AFD' }
			],
			selectLegend: 'ReportAvgScore',
			sortRule: 0, // 0-降序  1-升序  
		};
	},
	computed: {
		...Vuex.mapState('supervisor', ['GetReportListArr']),
		...Vuex.mapState('breadcrumb', ['breadLists']),
		...Vuex.mapState('visualization', ['doctorsHospital', 'trigger', 'setDateArr', 'portiaitbreadcrumbList'])
	},
	mounted() {
		let _this = this;
		this.erd.listenTo(document.getElementsByClassName('el-main'), function(element) {
			if (_this.myChart) {
				let dom = document.getElementById('container');
				if (dom) {
					dom.style.width = _this.$refs.breadcrumb.offsetWidth - 40 + 'px';
					_this.myChart.resize();
					_this.getEcharts();
				}
			}
		});
	},
	watch: {
		doctorsHospital(old) {
			let _this = this;
			if (this.trigger.hospital) {
				this.trigger.hospital = false;
				if (this.doctorsHospital.length > 0) {
					this.$nextTick(() => {
						_this.getEcharts();
					});
				}
			}
		}
	},
	updated() {
		let _this = this;
		if (this.trigger.hospital) {
			this.trigger.hospital = false;
			if (this.doctorsHospital.length > 0) {
				this.$nextTick(() => {
					_this.getEcharts();
				});
			}
		}
	},
	methods: {
		...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
		...Vuex.mapMutations('supervisor', ['currentChangesSecond']),
		...Vuex.mapMutations('visualization', ['setvisBreadcrumbList', 'setportiaitbreadcrumbList']),
		getEcharts() {
			// 获取配置项
			const config = this.legend.find(item => item.field === this.selectLegend)
			let _this = this;
			let dom = document.getElementById('container');
			dom.style.width = this.$refs.breadcrumb.offsetWidth + 'px';
			this.height = 25;
			this.myChart = echarts.init(dom);
			let data = [];
			let seriesData = []
			let minNumber = 0;
			if (this.doctorsHospital.length > 0) {
				let list = lodash.cloneDeep(this.doctorsHospital)
				list.sort((a, b) => {
					return this.sortRule === 0 ? Number(a[this.selectLegend]) -  Number(b[this.selectLegend]) : Number(b[this.selectLegend]) -  Number(a[this.selectLegend])
				})
				console.log(list, 'list1',this.sortRule ===0 ? '降序' : '升序');
				// 最多显示25家中心
				if (list.length > 25) {
					list = list.slice(0, 25)
				}
				// echart 数据处理
				list.forEach(element => {
					data.push({
						value: element.HospitalName
					});
					seriesData.push({
						value: element[this.selectLegend],
						sampledNum: element.SampledNum,
						hospitalGuid: element.HospitalGuid
					})
				})
			} else {
				data = [];
				seriesData = [];
			}
			
			this.barHeight = data.length * this.height < 150 ? data.length * this.height + 50 : data.length * this.height;
			dom.style.height = (this.barHeight / 900) * 100 + 'vh';
			let option = null;
			option = {
				color: config.color,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'none'
					},
					formatter: function(params, ticket, callback) {
						return `报告数: ${params[0].data.sampledNum}份`;
					}
				},
				grid: {
					top: 10,
					left: '3%',
					right: '6%',
					bottom: 10,
					containLabel: true
				},
				xAxis: [
					{
						type: 'value',
						// max:100,
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#112D66'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#ffffff',
								fontSize: this.fontSize(0.12)
							},
							formatter (value) {
							  return Math.abs(value)+minNumber // 负数取绝对值变正数（x轴本来数据是正负才能分开两边展示的，所以我们只是把负数处理为正数在视觉上显示）
							}
						},
						splitLine: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'category',
						// 按数据本身顺序从上到下展示：索引 0 在最上方，依次向下
						inverse: true,
						data: data,
						triggerEvent: true,
						axisTick: {
							show: false
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							// margin:95,
							interval: 0,
							rotate: 1,
							textStyle: {
								color: '#fff',
								fontSize: this.fontSize(0.12)
								// align: 'left'
							}
						},
						splitLine: {
							show: false
						}
					}
				],
				series: [
					{
						barMaxWidth: this.fontSize(0.09),
						barMinHeight: 20,
						name: config.label,
						type: 'bar',
						stack: '分数',
						itemStyle: {
							barBorderRadius: [0, 10, 10, 0]
						},
						label: {
							normal: {
								show: true,
								color: '#ffffff',
								align: 'left',
								fontSize: this.fontSize(0.1),
								fontWeight: 'bolder',
								// 自定义条形图上显示的文字
								formatter(params) {
									return Math.abs(params.value)+minNumber;
								}
							}
						},
						data: seriesData
					},
				]
			};
			if (option && typeof option === 'object') {
				this.myChart.clear();
				this.myChart.setOption(option, true);
				this.myChart.off('click'); //清除联系点击
				this.myChart.on('click', params => {
					this.setTootipType(false);
					this.clearRow();
					this.currentChangesSecond(1);
					this.setportiaitbreadcrumbList();
					this.portiaitbreadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
					this.GetReportListArr.type = params.name;
					this.portiaitbreadcrumbList.push(params.name);
					this.portiaitbreadcrumbList.push('portrait');
					this.GetReportListArr.name = params.name;
					this.GetReportListArr.hospitalGuid = params.data.hospitalGuid;
					_this.$router.push('/home/visualization/visImageCenter');
				});

				this.myChart.resize(); //区域更新
				window.addEventListener('resize', () => {
					this.myChart.resize();
				});
			}
		},
		// 排序
		dataSort() {
			this.sortRule = this.sortRule === 1 ? 0 : 1
			this.getEcharts()
		},
		// 切换 影像/报告
		switchLegend(current) {
			this.selectLegend = current.field
			this.getEcharts()
		}
	}
};
</script>
<style lang="scss" scoped>
.title {
	display: flex;
	align-items: center;
	.sort-icon {
		margin-left: 6px;
		cursor: pointer;
	}
}
.legend-list {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: 13px;
	padding-right: 28px;
	.legend-item {
		display: flex;
		align-items: center;
		margin-left: 8px;
		cursor: pointer;
		.square {
			width: 10px;
			height: 10px;
			background-color: #a4a4a9;
			border-radius: 2px;
			margin-right: 4px;
		}
		.label {
			color: #b3b4b5;
		}
	}
}

</style>
